export default "/assets/images/twilight-blue.43e793e2dd0d3ed1.jpg";